import Axios from '../axios.js'

/**
 * 工单消息接口
 */
export default {
	/**
	 * 添加一条消息记录
	 * @param {String} orderId 工单id，必填
	 * @param {String} content 消息内容,当消息类型不为文本时，content值为附件id
	 * @param {String} messageType 消息类型 :time_时间轴类型/words_文字类/其他使用附件的后缀名，上传附件时，将附件id作为content
	 */
	sendMessage: (orderId, content, messageType, success, failure) => {
		Axios.post('/orderMessage/sendMessage.do', {
			orderId,
			content,
			messageType
		}, success, failure);
	},
	/**
	 * 查询聊天信息,是倒序的
	 * @param {String} orderId 工单id，必填
	 * @param {int} pageIndex 必填
	 * @param {pageSize} pageSize 必填
	 * @param {bgTime} bgTime 必填
	 */
	searchMessage: (orderId, pageIndex, pageSize, bgTime, success, failure) => {
		Axios.post('/orderMessage/searchMessage.do', {
			orderId,
			pageIndex,
			pageSize,
			bgTime
		}, success, failure);
	},
	/**
	 * 查询图片资源集合
	 * @param {String} pkids 资源id，必填，多个用逗号隔开
	 */
	searchOrderPicture: (pkids, success, failure) => {
		Axios.post('/orderMessage/searchOrderPicture.do', {
			pkids
		}, success, failure);
	},
	/**
	 * 查询工单的进度轴
	 */
	searchActionMessageAndNodes: (orderId, success, failure) => {
		Axios.post('/orderMessage/searchActionMessageAndNodes.do', {
			orderId
		}, success, failure);
	},
}
